/**
 * ETP Search Results – clear-button behaviour for the search input.
 *
 * On X-button click: empties the input, hides the button, refocuses the input.
 * On input typing: toggles the X-button visibility so it appears only when
 * there is text to clear.
 */

export function initSearchResults(scope) {
  const roots = (scope || document).querySelectorAll(
    '.etp-search-results:not([data-etp-sr-ready])'
  );

  roots.forEach((root) => {
    const input = root.querySelector('[data-etp-sr-input]');
    const clear = root.querySelector('[data-etp-sr-clear]');

    if (!input || !clear) return;

    const sync = () => {
      if (input.value.length > 0) {
        clear.removeAttribute('hidden');
      } else {
        clear.setAttribute('hidden', '');
      }
    };

    input.addEventListener('input', sync);

    clear.addEventListener('click', () => {
      input.value = '';
      sync();
      input.focus();
    });

    root.dataset.etpSrReady = 'true';
  });
}
